import { useContext } from 'react';

import { CtaContext, type CtaContextProps } from './CtaProvider';

export function useCta(): CtaContextProps {
  const cta = useContext(CtaContext);

  return cta;
}
